module.exports = __webpack_public_path__ + "img/wind-driven-rain.4333f9f2.jpg";